<template>
  <div class="table-page-container">
    <!-- 顶部操作工具栏插槽 -->
    <slot name="toolbar"></slot>

    <!-- 顶部页码分页栏 -->
    <div v-if="showTopPagination && total > 0" class="top-pagination-container">
      <table-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 表格核心卡片容器 -->
    <div class="table-main-card">
      <div v-loading="loading" :class="['table-content-area', { 'has-state': loading || error || noPermission || empty }]">
        <!-- 默认插槽：放置 el-table -->
        <slot></slot>

        <!-- 遮罩层状态：失败、无权限、空数据 -->
        <div v-if="error" class="state-overlay">
          <div class="state-content">
            <i class="el-icon-warning-outline error-icon"></i>
            <h4 class="state-title">数据加载失败</h4>
            <p class="state-desc">网络好像出现了一点问题，请尝试重新加载</p>
            <el-button type="primary" size="small" icon="el-icon-refresh-right" class="btn-retry" @click="$emit('retry')">重新加载</el-button>
          </div>
        </div>

        <div v-else-if="noPermission" class="state-overlay">
          <div class="state-content">
            <i class="el-icon-lock lock-icon"></i>
            <h4 class="state-title">无查看权限</h4>
            <p class="state-desc">您暂时没有权限查看此板块内容，请联系管理员申请权限</p>
          </div>
        </div>

        <div v-else-if="empty && !loading" class="state-overlay">
          <el-empty description="暂无数据" :image-size="96"></el-empty>
        </div>
      </div>
    </div>

    <!-- 底部页码分页栏 -->
    <div v-if="showBottomPagination && total > 0" class="bottom-pagination-container">
      <table-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import TablePagination from '../TablePagination/index.vue'

export default {
  name: 'TablePage',
  components: { TablePagination },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    noPermission: {
      type: Boolean,
      default: false
    },
    empty: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    },
    total: {
      type: Number,
      default: 0
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100, 200]
    },
    showTopPagination: {
      type: Boolean,
      default: true
    },
    showBottomPagination: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleSizeChange (size) {
      this.$emit('update:pageSize', size)
      this.$emit('size-change', size)
    },
    handleCurrentChange (page) {
      this.$emit('update:currentPage', page)
      this.$emit('current-change', page)
    }
  }
}
</script>

<style scoped>
.table-page-container {
  width: 100%;
}
.top-pagination-container {
  margin-bottom: 12px;
  background: var(--bg-card);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-base);
}
.bottom-pagination-container {
  margin-top: 16px;
  background: var(--bg-card);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-base);
}
.table-main-card {
  background: var(--bg-card);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-base);
  overflow: hidden;
}
.table-content-area {
  position: relative;
  width: 100%;
}

.table-content-area.has-state {
  min-height: 200px;
}

/* 状态覆盖层设计 */
.state-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--bg-overlay);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 40px;
}
.state-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 360px;
}
.error-icon {
  font-size: 48px;
  color: #EF4444;
  margin-bottom: 16px;
}
.lock-icon {
  font-size: 48px;
  color: #F59E0B;
  margin-bottom: 16px;
}
.state-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-main);
  margin: 0 0 8px;
}
.state-desc {
  font-size: 13px;
  color: var(--text-muted);
  margin: 0 0 20px;
  line-height: 1.5;
}
.btn-retry {
  border-radius: 8px;
  font-weight: 600;
  padding: 8px 16px;
}
</style>
